import { createContext, useContext, ReactNode } from "react";
import { useIsFeatureFlagEnabled } from "../featureFlags/useIsFeatureFlagEnabled";
import { useMaintenanceStatus } from "../hooks/react-query/useMaintenanceStatus";

interface MaintenanceContextValue {
  isMaintenanceMode: boolean;
  isLoading: boolean;
  isFeatureEnabled: boolean;
}

const MaintenanceContext = createContext<MaintenanceContextValue | null>(null);

interface MaintenanceProviderProps {
  children: ReactNode;
}

export function MaintenanceProvider({ children }: MaintenanceProviderProps) {
  const isFeatureEnabled = useIsFeatureFlagEnabled(
    "apex-DIS-2032-maintenance-client"
  );
  const { data, isLoading } = useMaintenanceStatus(isFeatureEnabled);

  const isMaintenanceMode = data?.enabled ?? false;

  return (
    <MaintenanceContext.Provider
      value={{ isMaintenanceMode, isLoading, isFeatureEnabled }}
    >
      {children}
    </MaintenanceContext.Provider>
  );
}

export function useMaintenanceContext(): MaintenanceContextValue {
  const context = useContext(MaintenanceContext);
  if (!context) {
    throw new Error(
      "useMaintenanceContext must be used within MaintenanceProvider"
    );
  }
  return context;
}
